module.exports = __webpack_public_path__ + "93683ff24a9fa2f1e796f892a75cd63f.png";